export default __webpack_public_path__ + "static/media/050-danger.ac4d93e8.png";